"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multipleArtifacts = exports.forStoryArtifact = exports.basic = void 0;
exports.basic = {
    RT: {
        codeType: "Modifier",
        code: "RT",
        description: "Right side (used to identify procedures performed on the right side of the body)",
        shortDescription: "Right side (used to identify procedures performed on the right side of the body)",
        tenantDefined: true
    },
    LT: {
        codeType: "Modifier",
        code: "LT",
        description: "Left side (used to identify procedures performed on the left side of the body)",
        shortDescription: "Right side (used to identify procedures performed on the right side of the body)",
        tenantDefined: true
    },
    "28890": {
        codeType: "CPT",
        code: "28890",
        description: "ESWT HI NRG PHYS/QHP W/US GDN INVG PLNTAR FASCIA",
        shortDescription: "Right side (used to identify procedures performed on the right side of the body)",
        tenantDefined: true
    },
    "A15.0": {
        tenantDefined: true,
        codeType: "ICD",
        code: "A15.0",
        shortDescription: "Tuberculosis of lung",
        description: "Tuberculosis of lung"
    }
};
exports.forStoryArtifact = {
    "26": {
        code: "26",
        codeType: "CPT",
        description: "Professional Component",
        shortDescription: "Professional Component",
        tenantDefined: true
    },
    "73630": {
        codeType: "CPT",
        code: "73630",
        description: "RADEX FOOT COMPLETE MINIMUM 3 VIEWS",
        shortDescription: "RADEX FOOT COMPLETE MINIMUM 3 VIEWS",
        tenantDefined: true
    },
    "R60.0": {
        codeType: "ICD",
        code: "R60.0",
        description: "Localized edema",
        shortDescription: "Localized edema",
        tenantDefined: true
    },
    "Q66.6": {
        codeType: "ICD",
        code: "Q66.6",
        shortDescription: "Other congenital valgus deformities of feet",
        description: "Other congenital valgus deformities of feet",
        tenantDefined: true
    },
    "M19.071S": {
        codeType: "ICD",
        code: "M19.071S",
        shortDescription: "Primary osteoarthritis, right ankle and foot",
        description: "Primary osteoarthritis, right ankle and foot",
        tenantDefined: true
    },
    LT: {
        codeType: "Modifier",
        code: "LT",
        shortDescription: "Left side (used to identify procedures performed on the left side of the body)",
        description: "Left side (used to identify procedures performed on the left side of the body)",
        tenantDefined: true
    },
    GC: {
        code: "GC",
        codeType: "Modifier",
        shortDescription: "This service has been performed in part by a resident under the direction of a teaching physician",
        description: "This service has been performed in part by a resident under the direction of a teaching physician",
        tenantDefined: true
    },
    "70450": {
        codeType: "CPT",
        code: "70450",
        description: "CT HEAD/BRAIN W/O CONTRAST MATERIAL",
        shortDescription: "CT HEAD/BRAIN W/O CONTRAST MATERIAL",
        tenantDefined: true
    },
    "R16.0": {
        code: "R16.0",
        codeType: "ICD",
        shortDescription: "Hepatomegaly, not elsewhere classified",
        description: "Hepatomegaly, not elsewhere classified",
        tenantDefined: true
    },
    "R10.11": {
        code: "R10.11",
        codeType: "ICD",
        shortDescription: "Right upper quadrant pain",
        description: "Right upper quadrant pain",
        tenantDefined: true
    }
};
exports.multipleArtifacts = {
    "73030": {
        code: "73030",
        codeType: "CPT",
        shortDescription: "RADEX SHOULDER COMPLETE MINIMUM 2 VIEWS",
        description: "RADEX SHOULDER COMPLETE MINIMUM 2 VIEWS",
        tenantDefined: true
    },
    "77067": {
        code: "77067",
        codeType: "CPT",
        shortDescription: "SCREENING MAMMOGRAPHY BI 2-VIEW BREAST INC CAD",
        description: "SCREENING MAMMOGRAPHY BI 2-VIEW BREAST INC CAD",
        tenantDefined: true
    },
    "R60.0": {
        code: "R60.0",
        codeType: "ICD",
        shortDescription: "Localized edema",
        description: "Localized edema",
        tenantDefined: true
    },
    LT: {
        code: "LT",
        codeType: "Modifier",
        shortDescription: "Left side (used to identify procedures performed on the left side of the body)",
        description: "Left side (used to identify procedures performed on the left side of the body)",
        tenantDefined: true
    },
    "M19.012": {
        code: "M19.012",
        codeType: "Modifier",
        shortDescription: "Primary osteoarthritis, left shoulder",
        description: "Primary osteoarthritis, left shoulder",
        tenantDefined: true
    }
};
//# sourceMappingURL=code-descriptions.js.map